var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferenceLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H12V2L14 2V4H12V6H10V4H8V2L10 2V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2H7V4H3C2.44772 4 2 4.44772 2 5V9.17071C2.31278 9.06015 2.64936 9 3 9H10V7H12V13C12 14.6569 10.6569 16 9 16H3C1.34315 16 0 14.6569 0 13V5C0 3.34315 1.34315 2 3 2ZM10 12V11H3C2.44772 11 2 11.4477 2 12V13C2 13.5523 2.44772 14 3 14H9C9.55228 14 10 13.5523 10 13H3.5C3.22386 13 3 12.7761 3 12.5C3 12.2239 3.22386 12 3.5 12H10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferenceLink);
export default __webpack_public_path__ + "static/media/ReferenceLink.8b973d9bee9e50fa83ec9a6856f07a60.svg";
export { ForwardRef as ReactComponent };